// src/pages/ProfileMenu.js
import React from 'react';
import {
    Container,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Typography,
    Switch,
    Box,
    Divider
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import {
    Person,
    Assignment,
    ExitToApp,
    SwapHoriz,
    Inventory
} from '@mui/icons-material';
import { useAuth } from '../context/AuthContext';
import { useMode } from '../context/ModeContext';

const StyledContainer = styled(Container)(({ theme }) => ({
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(4),
}));

const ModeSwitch = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
}));

function ProfileMenu() {
    const navigate = useNavigate();
    const { logout } = useAuth();
    const { mode, toggleMode } = useMode();

    const handleLogout = () => {
        logout();
        navigate('/');
    };

    return (
        <StyledContainer>
            <ModeSwitch>
                <SwapHoriz />
                <Typography variant="body1" sx={{ flex: 1, ml: 2 }}>
                    {mode === 'Borrowing' ? 'Borrower Mode' : 'Lender Mode'}
                </Typography>
                <Switch
                    checked={mode === 'Lending'}
                    onChange={toggleMode}
                    inputProps={{ 'aria-label': 'mode toggle' }}
                />
            </ModeSwitch>

            <Divider />

            <List>
                <ListItem button onClick={() => navigate('/profile')}>
                    <ListItemIcon>
                        <Person />
                    </ListItemIcon>
                    <ListItemText primary="My Profile" />
                </ListItem>

                {mode === 'Borrowing' ? (
                    <ListItem button onClick={() => navigate('/bookings')}>
                        <ListItemIcon>
                            <Assignment />
                        </ListItemIcon>
                        <ListItemText primary="My Bookings" />
                    </ListItem>
                ) : (
                    <>
                        <ListItem button onClick={() => navigate('/lending-bookings')}>
                            <ListItemIcon>
                                <Assignment />
                            </ListItemIcon>
                            <ListItemText primary="Booking Requests" />
                        </ListItem>
                        <ListItem button onClick={() => navigate('/my-listings')}>
                            <ListItemIcon>
                                <Inventory />
                            </ListItemIcon>
                            <ListItemText primary="My Listings" />
                        </ListItem>
                    </>
                )}

                <Divider />

                <ListItem button onClick={handleLogout}>
                    <ListItemIcon>
                        <ExitToApp />
                    </ListItemIcon>
                    <ListItemText primary="Logout" />
                </ListItem>
            </List>
        </StyledContainer>
    );
}

export default ProfileMenu;